// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3imPF","clinicsSelect":"styles_clinicsSelect__3jIVk"};